import { Divider, ListItem, ListItemText, Stack } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { DiscList } from "components/common/DiscList/DiscList";
import {
  SDK_DOCS_URL
} from "config/constants";
import { HelpMessage } from "new-components/helpMessage/HelpMessage";
import { Typography } from "new-components/typography/Typography";

export function EmptyStateDetectorsList() {
  return (
    <Stack
      className="mt-[90px] max-w-[1100px] w-full mx-auto"
      divider={<Divider className="border-black/[.15]" orientation="horizontal" flexItem variant="middle" />}
      spacing={3}
    >
      <Typography fontWeight="semibold">
        Welcome to the detectors page!
      </Typography>

      <Stack spacing={2}>
        <Typography>
          Each detector you create answers a specific question about images from your application.
        </Typography>

      <DiscList>
          <ListItem>
            <ListItemText
              primary={
                <>
                  New to Groundlight? Try things out with the{" "}
                  <Link to="/reef/quickstart" className="font-semibold text-primary-dark">
                    Demo
                  </Link>{" "}
                  page first.
                </>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemText
              primary={
                <>
                  Ready to use your Groundlight detectors in a Python application? Review our{" "}
                  <Link
                    className="font-semibold text-primary-dark no-underline"
                    to={SDK_DOCS_URL}
                    target="_blank"
                  >
                    docs
                  </Link>{" "}
                  to learn how to build computer vision applications.
                </>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemText
              primary={
                <HelpMessage startText="Need some help?" topic="with any questions about how to integrate Groundlight into your application." />
              }
            />
          </ListItem>
        </DiscList>
      </Stack>
    </Stack>
  );
}
